function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__ic_mega-a",
  x1: "63.734%",
  x2: "34.478%",
  y1: "101.793%",
  y2: "9.702%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0.33
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__ic_mega-b",
  x1: "96.187%",
  x2: "7.879%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0.33
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__ic_mega-c",
  x1: "7.278%",
  x2: "96.464%",
  y1: "43.743%",
  y2: "52.776%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0.33
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__ic_mega-d",
  x1: "30.724%",
  x2: "70.181%",
  y1: "-.719%",
  y2: "86.478%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0.33
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#815E3C",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__ic_mega-a)",
  fillRule: "nonzero",
  d: "M6.263 8.2c-.05-.887.25-1.8.925-2.575a8 8 0 0 0-3.1 5.25C4.038 11.25 4 11.625 4 12s.025.75.075 1.125c.775 2.438 4.05 4.275 7.937 4.275V12c-3.725 0-5.637-1.85-5.75-3.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__ic_mega-b)",
  fillRule: "nonzero",
  d: "M17.913 15.713C16.437 16.75 14.35 17.4 12.025 17.4c-3.9 0-7.163-1.837-7.938-4.275C4.638 17 7.963 20 12 20h.012a7.926 7.926 0 0 0 5.35-2.063c.463-.712.638-1.475.55-2.225z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__ic_mega-c)",
  fillRule: "nonzero",
  d: "M12.012 4A7.91 7.91 0 0 0 7.2 5.612c-.663.776-.975 1.7-.925 2.575 1.475-.974 3.5-1.587 5.75-1.587 3.8 0 7.013 1.75 7.875 4.113A8.02 8.02 0 0 0 12.013 4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__ic_mega-d)",
  fillRule: "nonzero",
  d: "M19.887 10.713C19.026 8.35 15.825 6.6 12.012 6.6V12h.013c3.6 0 5.65 1.775 5.875 3.713.088.737-.087 1.512-.537 2.212a7.938 7.938 0 0 0 2.524-4.638c.063-.412.1-.85.1-1.287a6.319 6.319 0 0 0-.1-1.287z"
}));

var SvgIcMega = function SvgIcMega(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMega, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_mega.984fecda.svg";
export { ForwardRef as ReactComponent };